import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

// The mockup sits the composer's attach button, input and Send on one 36px-tall row.
export const MESSAGE_CONTROL_HEIGHT_IN_PX = 36;

type MessageInputShellProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

/** The composer's chrome, shared so an inline edit is framed like the box it replaces. */
export default function MessageInputShell({ children, sx }: MessageInputShellProps) {
  const theme = useTheme();

  return (
    <Box
      sx={[
        {
          border: `1px solid ${theme.semantic.border}`,
          borderRadius: theme.brandV2.borderRadius,
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          p: 1,
          // A shadow rather than a thicker border, so the box does not resize.
          '&:focus-within': {
            borderColor: theme.brandV2.colors.treadYellow,
            boxShadow: `0 0 0 1px ${theme.brandV2.colors.treadYellow}`,
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
